import React, {useState, useEffect} from "react";
import { Button } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux";
import { addToFavorite } from '../store/action/addToFavorite.js'

const TableCharacter = ({mappingCharacter, index}) => {
    const [isFavorite, setIsFavorite] = useState(false)
    const dispatch = useDispatch()
    const history = useHistory()
    const favoriteCharacters = useSelector((state) => state.favoriteReducer.favoriteCharacters)

    useEffect(() => {
        const checkFavorite = favoriteCharacters.filter(favorite => favorite._id === mappingCharacter._id)
        if(checkFavorite.length > 0) {
            console.log(checkFavorite)
            setIsFavorite(true)
        }
    }, [favoriteCharacters])

    const clickedDetailBtn = (id) => {
        history.push(`/character/${id}`)
    }

    const clickedFavBtn = (character) => {
        dispatch(addToFavorite(character))
    }

    return (
        <>
            <tr>
                <th>{+index + 1}</th>
                <td>{mappingCharacter.name}</td>
                <td>{mappingCharacter.house ? mappingCharacter.house :'None'}</td>
                <td>{mappingCharacter.role ? mappingCharacter.role : 'N/A'}</td>
                <td>{mappingCharacter.school ? mappingCharacter.school :'N/A'}</td>
                <td>
                    {
                        !isFavorite && <Button variant="outline-warning" id="button-detail" onClick={() => clickedFavBtn(mappingCharacter)} >Add to Favorite</Button>
                    }
                    <Button variant="outline-info" id="button-detail" onClick={() => clickedDetailBtn(mappingCharacter._id)} >See Detail</Button>
                </td>

            </tr>
        </>
    )

}

export default TableCharacter
